module.exports = {"652902001":"热斯坦街道","652902002":"萨克萨克街道","652902003":"新城街道","652902004":"东城街道","652902101":"乌恰镇","652902102":"阿拉哈格镇","652902103":"齐满镇","652902104":"墩阔坦镇","652902105":"牙哈镇","652902106":"乌尊镇","652902107":"伊西哈拉镇","652902108":"二八台镇","652902201":"玉奇吾斯塘乡","652902202":"比西巴格乡","652902203":"哈尼喀塔木乡","652902204":"阿克吾斯塘乡","652902205":"阿格乡","652902206":"塔里木乡","652902500":"库车经济技术开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/652902.json
// module id = 3234
// module chunks = 0